export default __webpack_public_path__ + "static/media/warning.ab9367ee.svg";